<template>
    <div class="container-fluid request-3d-print-block">
        <div class="row justify-content-center">
            <div class="col-md-12 px-0 mx-0 ">
<!--                <ul class="d-flex breadcrumb-list">-->
<!--                    <li class="breadcrumb-item"><a href="/" class="text-decoration-none">{{ breadCrumbs.home }} </a></li>-->
<!--                    <li class="breadcrumb-item active">{{ breadCrumbs.active }}</li>-->
<!--                </ul>-->

                <div class="question-block">
                    <div class="position-relative d-flex flex-column">


                        <div class="d-flex flex-column flex-md-row">
                            <div class=" col-md-6   pe-md-3" v-if="active">
                                <div class="d-flex contacts__block-header align-items-center align-items-md-start flex-column mb-4">
                                    <h1 class=" me-5 ms-0 header-title">{{ title && title }}</h1>
                                    <p >{{ description }}</p>
                                </div>
                                <div class="contacts__block ">
                                    <div class="d-flex flex-column">
                                        <div class=" mt-5 mt-md-0">
                                            <a class="text-decoration-none "
                                               v-if="!this.phoneStatus"
                                               href="https://api.whatsapp.com/send/?phone=966532717993&text&type=phone_number&app_absent=0">
                                                <h3><img src="/images/icons/phone.svg" class="phone-img" alt=""> {{ titles.phone }}
                                                </h3>
                                            </a>
                                            <a class="text-decoration-none "
                                               v-else
                                               :href="'tel:' + +phone.text">
                                                <h3><img src="/images/icons/phone.svg" class="phone-img" alt=""> {{ titles.phone }}
                                                </h3>
                                            </a>

                                            <a class="text-decoration-none" href="https://api.whatsapp.com/send/?phone=966532717993&text&type=phone_number&app_absent=0">
                                                <p style="text-decoration: underline!important;" class="phone-data">
                                                    {{ phone.text }}
                                                    <svg style="margin-left:6px; margin-bottom: 4px; margin-right: 6px;" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58" xml:space="preserve">
                                                        <g>
                                                            <path style="fill:#2CB742;" d="M0,58l4.988-14.963C2.457,38.78,1,33.812,1,28.5C1,12.76,13.76,0,29.5,0S58,12.76,58,28.5
                                                                S45.24,57,29.5,57c-4.789,0-9.299-1.187-13.26-3.273L0,58z"/>
                                                            <path style="fill:#FFFFFF;" d="M47.683,37.985c-1.316-2.487-6.169-5.331-6.169-5.331c-1.098-0.626-2.423-0.696-3.049,0.42
                                                                c0,0-1.577,1.891-1.978,2.163c-1.832,1.241-3.529,1.193-5.242-0.52l-3.981-3.981l-3.981-3.981c-1.713-1.713-1.761-3.41-0.52-5.242
                                                                c0.272-0.401,2.163-1.978,2.163-1.978c1.116-0.627,1.046-1.951,0.42-3.049c0,0-2.844-4.853-5.331-6.169
                                                                c-1.058-0.56-2.357-0.364-3.203,0.482l-1.758,1.758c-5.577,5.577-2.831,11.873,2.746,17.45l5.097,5.097l5.097,5.097
                                                                c5.577,5.577,11.873,8.323,17.45,2.746l1.758-1.758C48.048,40.341,48.243,39.042,47.683,37.985z"/>
                                                        </g>
                                                    </svg>
                                                </p>
                                            </a>

                                        </div>
                                        <div class="mt-5">
                                            <a :href='"mailto:" + email' class="text-decoration-none">
                                                <h3><img src="/images/icons/mail.svg" alt=""> {{ titles.email }}</h3>
                                                <p style="text-decoration: underline!important;" class="ms-5 ps-3"> {{ email }}</p>
                                            </a>
                                        </div>
                                        <div class="mt-5 mb-3">
                                            <h3><img src="/images/icons/location.svg" alt=""> {{ titles.location }}</h3>
                                            <p class="ms-5 ps-3">{{ location }}</p>
                                        </div>
                                        <div
                                            class=" d-flex social__block ms-0 me-0 mt-5">
                                            <a class="text-decoration-none"
                                               :href="socialLink.instagram.link"><img
                                                src="/images/icons/inst.svg"
                                                class="icons__img"
                                                alt="#"></a>

                                            <a class="text-decoration-none  "
                                               :href="socialLink.whatsApp.link"><img
                                                src="/images/icons/whatsapp.svg" class="icons__img" alt="#"></a>

                                            <a class="text-decoration-none  "
                                               :href="socialLink.tikTok.link"><img
                                                src="/images/icons/social.svg" class="icons__img" alt="#"></a>
                                            <a class="text-decoration-none "
                                               :href="socialLink.twitter.link"><img
                                                src="/images/icons/twitter.svg" class="icons__img" alt="#"></a>
                                            <a class="text-decoration-none  " :href="socialLink.snapchat.link"><img
                                                src="/images/icons/snapchat.svg" class="icons__img" alt="#"></a>

                                        </div>
                                    </div>



                                </div>
                            </div>
                            <div class="ps-md-3 col-md-6" :class="{'mx-auto': (!active)}">
                                <div class=" form-request__block">
                                    <TheLoaderComponent v-if="showLoader"></TheLoaderComponent>

                                    <form class="js-email-form" method="post">

                                        <p>{{titles.titleHeaderSectionMail}}</p>
                                        <div class="form-group justify-content-between w-100">
                                            <div class="mb-4">
                                                <label class="form-label">{{ titles.firstName }}</label>
                                                <input type="text" class="clear-error js-email-name"
                                                       v-model="dataSendQuestion['first_name']" name="first_name"/>
                                                <span class="error-text" role="alert" style="color: red">
                                                    <strong></strong>
                                                </span>
                                            </div>
                                            <div class="mb-4">
                                                <label class="form-label">{{ titles.lastName }}</label>
                                                <input type="text" class="clear-error js-email-name"
                                                       v-model="dataSendQuestion['last_name']" name="last_name"/>
                                                <span class="error-text" role="alert" style="color: red">
                                                    <strong></strong>
                                                </span>
                                            </div>

                                            <div class=" mb-4 form-group">
                                                <label class="form-label">{{ titles.email }}</label>
                                                <input type="email" class="clear-error js-email-email"
                                                       v-model="dataSendQuestion['email']" name="email"/>
                                                <span class="error-text" role="alert" style="color: red">
                                                    <strong></strong>
                                                </span>
                                            </div>

                                            <div class="position-relative mb-4 form-group" v-if="themeQuestions">
                                                <label>{{ titles.category }}</label>
                                                <v-select
                                                    v-model="dataSendQuestion['question_theme_id']"
                                                    :options="themeQuestions"
                                                    :clearable="false"
                                                    placeholder="Choose Category" class="input clear-error">
                                                    <template #open-indicator="{ attributes }" #val>
                                                    <span v-bind="attributes">
                                                        <img class="select-img" src="/images/icons/vector.png"/>
                                                    </span>
                                                    </template>
                                                </v-select>
                                                <span class="error-text js-question-id__error d-none" role="alert"
                                                      style="color: red">
                                                    <strong></strong>
                                                </span>
                                            </div>

                                            <div class="mb-4 form-group">
                                                <label class="form-label">{{ titles.message }}</label>
                                                <textarea name="question" class="clear-error js-email-question mb-0"
                                                          v-model="dataSendQuestion['question']"
                                                ></textarea>
                                                <span class="error-text js-question__error d-none" role="alert"
                                                      style="color: red">
                                                    <strong>The question field is required.</strong>
                                                </span>
                                            </div>
                                        </div>

                                        <Recaptcha @verified="onCaptchaVerified" />

                                        <button type="button"
                                                @click="sendQuestion"
                                                class="btn btn-purple mt-5 h-auto  d-flex  w-100 justify-content-center js-send-email">
                                            {{ titles.sendBtn }}
                                        </button>

                                    </form>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="application/javascript">

import TheLoaderComponent from "./TheLoaderComponent";
import DropFileComponent from "./DropFileComponent";
import {validation} from "../helpers/validation";
import Recaptcha from "./Recaptcha.vue";

export default {
    components: {Recaptcha, TheLoaderComponent, DropFileComponent},

    data() {
        return {
            showLoader: false,
            themeQuestions: [],
            dataSendQuestion: [],
            title: '',
            description: '',
            email: '',
            phone: {
                link: '',
                text: ''
            },
            location: '',
            socialLink: {
                whatsApp: {
                    link: ''
                },
                tikTok: {
                    link: ''
                },
                instagram: {
                    link: ''
                },
                twitter: {
                    link: ''
                },
                snapchat: {
                    link: ''
                },
            },
            phoneStatus: false,
            active: false,
            titles: {
                phone: '',
                email: '',
                location: '',
                firstName: '',
                lastName: '',
                category: '',
                message: '',
                sendBtn: '',
                titleHeaderSectionMail: ''
            },
            breadCrumbs: {
                home: '',
                active: ''
            },
            captchaToken: null,
        }
    },
    watch: {},
    mounted() {
        this.getThemes()
        this.changeContent()
    },
    updated() {
        this.clearErrorInout()
        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
    },
    methods: {
        changeContent() {
            if (window.currentLang === 'ar-sa') {
                content[0].active && this.getContent(content[0].content_ar)
                this.titles.phone = 'هاتف'
                this.titles.email = 'البريد الإلكتروني'
                this.titles.location = 'الموقع'
                this.titles.firstName = 'الاسم الأول'
                this.titles.lastName = 'اسم العائلة'
                this.titles.category = 'نوع الدعم'
                this.titles.message = 'الرسالة'
                this.titles.sendBtn = 'إرسال'
                this.titles.titleHeaderSectionMail = 'قم بتعبئة النموذج وسوف يتم الرد عليك في أقرب وقت ممكن'

                this.breadCrumbs.home = 'الرئيسية'
                this.breadCrumbs.active = 'أتصل بنا'
            } else {
                this.breadCrumbs.home = 'Home'
                this.breadCrumbs.active = 'Contacts us'

                this.titles.titleHeaderSectionMail = 'Fill up the form and our team will get back to you'
                this.titles.phone = 'Phone'
                this.titles.email = 'Email'
                this.titles.location = 'Location'
                this.titles.firstName = 'First Name'
                this.titles.lastName = 'Last Name'
                this.titles.category = 'Category'
                this.titles.message = 'Message'
                this.titles.sendBtn = 'Send'
                content[0].active && this.getContent(content[0].content_en)
            }

            this.active = content[0].active
        },
        getContent(lang) {
            this.title = lang.title.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.description = lang.description.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.email = lang.email.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.phone.link = lang.phone.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.phone.text = lang.phone.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.location = lang.location.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.socialLink.whatsApp.link = lang.whatsapp.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.socialLink.tikTok.link = lang.tiktok.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.socialLink.instagram.link = lang.instagram.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.socialLink.snapchat.link = lang.snapchat.replace(/<\/?[a-zA-Z]+>/gi, '')
            this.socialLink.twitter.link = lang.twitter.replace(/<\/?[a-zA-Z]+>/gi, '')

            function validatePIN(pin) {
                const preparedPin = pin.replace(/\D/g, '');

                return preparedPin === pin;
            }

            this.phoneStatus = validatePIN(this.phone.text)
        },
        getThemes() {
            let vm = this

            axios.get('/contact-us/themes').then(function (response) {

                response.data.forEach(theme => {
                    let obj = {
                        val: theme.id,
                        label: theme.title
                    }
                    vm.themeQuestions.push(obj)
                })
            })
        },
        sendQuestion() {
            if (!this.captchaToken) {
                alert('Captcha error');
                return;
            }
            let vm = this
            vm.showLoader = true

            let form = document.querySelector('.js-email-form')
            let fomData = new FormData(form)
            fomData.append('recaptcha_token', this.captchaToken);
            vm.dataSendQuestion.question_theme_id && fomData.append('question_theme_id', +vm.dataSendQuestion.question_theme_id.val)

            axios.post('/contact-us/send', fomData).then(function (response) {
                vm.showLoader = false
                if (localStorage.getItem('lang') === 'ar-sa') {
                    window.notify('تم إرسال سؤالك', 'success')
                } else {
                    window.notify('Your question has been sent', 'success')
                }

            }).catch(function (xhr) {
                let questionError = document.querySelector('.js-question__error')
                let questionIdError = document.querySelector('.js-question-id__error')
                let response = xhr.response.data;

                vm.showLoader = false
                if (localStorage.getItem('lang') === 'ar-sa') {
                    window.notify('لم يتم إرسال سؤالك', 'error')
                } else {
                    window.notify('Your question has not been sent', 'error')
                }


                async function validateForm() {
                    validation(form, response.errors, true);
                }

                validateForm().then(function () {
                    if (vm.dataSendQuestion['question_theme_id'] === undefined) {
                        questionError.textContent = 'The question field is required.'
                        questionError.classList.remove('d-none')
                    }

                    if (vm.dataSendQuestion['question'] === undefined) {
                        questionIdError.textContent = 'The question id field is required.'
                        questionIdError.classList.remove('d-none')
                        questionIdError.style.display = 'block'
                    }
                })

            })
        },
        clearErrorInout() {
            let inputs = document.querySelectorAll('.clear-error')
            inputs.forEach(input => {
                input.addEventListener('click', e => {
                    let parent = e.target.closest('.form-group')
                    let child = parent.querySelector('.error-text')
                    child && (child.innerHTML = '')
                })
            })
            inputs.forEach(input => {
                input.addEventListener('input', e => {
                    let parent = e.target.closest('.form-group')
                    let child = parent.querySelector('.error-text')
                    child && (child.innerHTML = '')
                })
            })
        },
        onCaptchaVerified(token) {
            this.captchaToken = token;
        },
    }
}
</script>

<style lang="scss">
@import "../../sass/front/question";
</style>
